import { renderCMSComponent } from "~/CMSComponents/componentFactory";

import { useState } from "react";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import type { SchaefflerFormDTO } from "~/CMSComponents/dto";

export const useSchaefflerForm = (formId: string, onSuccess?: () => void) => {
  const [form, setForm] = useState<SchaefflerFormDTO | null>(null);
  const [loading, setLoading] = useState(false);

  return {
    renderForm: () => (form ? renderCMSComponent({ ...form, onSuccess }) : null),
    loadForm: async () => {
      if (loading || form) {
        return;
      }
      setLoading(true);
      const formData = await fetchForm(formId);
      setForm(formData);
      setLoading(false);
    },
    loading,
  };
};

const forms: Record<string, Promise<SchaefflerFormDTO> | undefined> = {};
const fetchForm = (formId: string) => {
  if (forms[formId]) {
    return forms[formId];
  }

  forms[formId] = apiFetchForm(formId);
  return forms[formId];
};

const apiFetchForm = async (formId: string): Promise<SchaefflerFormDTO> => {
  const url = resolveApiUrl(`/api/contact-form/${formId}`);
  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (!response.ok) {
    throw new Error("Error fetching product");
  }
  const dto = (await response.json()) as string;

  return JSON.parse(dto.replace(/\\/g, "")) as SchaefflerFormDTO;
};
